import { gql, useQuery } from '@apollo/client';
import { Account } from 'types/Account';

const GET_CUSTOM_MOSAIC = gql`
  query GetCustomMosaic($userId: Int, $email: String) {
    getCustomMosaic(userId: $userId, email: $email) {
      id
      userId
      name
      cameras
    }
  }
`;

export type CustomMosaic = {
  id: number;
  name: string;
  cameras: string[];
};

function useGetCustomMosaic({ accountSelected }: { accountSelected: Account }) {
  const { data, ...queryReturns } = useQuery<{
    getCustomMosaic: CustomMosaic[];
  }>(GET_CUSTOM_MOSAIC, {
    variables: {
      ...accountSelected,
    },
  });

  return {
    mosaics: data?.getCustomMosaic,
    ...queryReturns,
  };
}

export default useGetCustomMosaic;
